import { Box, Text } from '../index';
import { checkboxStyle, textStyle } from './SelectableButton.css';

export interface SelectableButtonProps {
  /**
   * Controls the text rendered inside the button
   */
  text: string;
  /**
   * Controls whether the button is selected or not
   */
  selected: boolean;
  /**
   * Function that is executed when button is selected
   */
  onClick: () => void;
  /**
   * Function that is executed when mouse enters the button
   */
  onHover: () => void;
}

export const SelectableButton = ({
  text,
  selected,
  onClick,
  onHover,
}: SelectableButtonProps): JSX.Element => (
  <Box
    component="button"
    className={checkboxStyle({ status: selected })}
    onClick={onClick}
    onMouseEnter={onHover}
    display="flex"
    alignItems="center"
    type="button"
  >
    <Text weight="demibold" className={textStyle}>
      {text}
    </Text>
  </Box>
);
